export default __webpack_public_path__ + "static/img/Onboarding_Panel_dark.da2034ff.svg";